var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_819_10162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.785 11.3516H7.42065C6.76816 11.352 6.14251 11.6113 5.68113 12.0727C5.21974 12.5341 4.96036 13.1598 4.95996 13.8123V58.187C4.96036 58.8395 5.21974 59.4651 5.68113 59.9265C6.14251 60.3879 6.76816 60.6473 7.42065 60.6477H55.785C56.4375 60.6473 57.0632 60.388 57.5247 59.9266C57.9861 59.4652 58.2455 58.8395 58.2459 58.187V13.8123C58.2455 13.1597 57.9861 12.534 57.5247 12.0726C57.0632 11.6112 56.4375 11.3519 55.785 11.3516Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6013 45.2225H10.6052C9.2463 45.2225 8.14453 44.1207 8.14453 42.7618V3.55444C8.14453 2.19552 9.2463 1.09375 10.6052 1.09375H52.6013C53.9602 1.09375 55.062 2.19552 55.062 3.55444V42.7618C55.062 44.1207 53.9602 45.2225 52.6013 45.2225Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9236 43.5406V4.3335C8.9236 2.97459 10.0254 1.87282 11.3843 1.87282H53.3804C53.8604 1.87282 54.3066 2.01232 54.6849 2.2499C54.2499 1.55621 53.4805 1.09375 52.6013 1.09375H10.6052C9.2463 1.09375 8.14453 2.19552 8.14453 3.55444V42.7618C8.14453 43.6412 8.60699 44.4104 9.30068 44.8457C9.0631 44.4671 8.9236 44.0209 8.9236 43.5409V43.5406Z",
    fill: "url(#paint0_linear_819_10162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4339 9.38281H15.7725V11.1872H47.4339V9.38281ZM47.4339 16.2724H15.7725V18.0768H47.4339V16.2724ZM47.4339 23.1636H15.7725V24.9679H47.4339V23.1636ZM47.4339 30.0532H15.7725V31.8578H47.4339V30.0532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5449 24.2266L27.501 32.1829H19.5449V24.2266Z",
    fill: "url(#paint1_linear_819_10162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2466 32.8419V14.5359L55.0625 11.3516V32.8417H58.2466V32.8419Z",
    fill: "#C6C6C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9753 34.4989L58.5447 58.7836C58.3732 59.9977 57.3342 60.9 56.1082 60.9H7.0972C5.87117 60.9 4.83216 59.9977 4.66065 58.7836L0.0246232 25.9691C-0.1845 24.4877 0.965041 23.1641 2.46117 23.1641H17.5968C18.8228 23.1641 19.8618 24.0664 20.0333 25.2802L20.6409 29.5775C20.8124 30.7916 21.8514 31.6939 23.0774 31.6939H59.5393C61.0349 31.6939 62.1847 33.0175 61.9756 34.4989H61.9753Z",
    fill: "url(#paint2_linear_819_10162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8204 50.0619H13.3855C13.1858 50.0618 12.993 49.989 12.8431 49.8569C12.6933 49.7249 12.5968 49.5427 12.5716 49.3446L12.1158 45.7354C12.1013 45.6199 12.1115 45.5027 12.1458 45.3915C12.1801 45.2803 12.2376 45.1777 12.3145 45.0904C12.3915 45.0031 12.4862 44.9332 12.5922 44.8853C12.6982 44.8374 12.8133 44.8126 12.9296 44.8125H50.2762C50.3926 44.8126 50.5076 44.8374 50.6137 44.8853C50.7197 44.9332 50.8144 45.0031 50.8913 45.0904C50.9683 45.1777 51.0258 45.2803 51.0601 45.3915C51.0944 45.5027 51.1046 45.6199 51.0901 45.7354L50.6343 49.3446C50.6091 49.5427 50.5126 49.7249 50.3628 49.8569C50.2129 49.989 50.0201 50.0618 49.8204 50.0619Z",
    fill: "#D5D5D5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_819_10162",
    x1: 33.0462,
    y1: 24.5984,
    x2: 1.92675,
    y2: -6.52133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_819_10162",
    x1: 24.8015,
    y1: 33.4595,
    x2: 15.1846,
    y2: 23.8429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CECE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179,
    stopColor: "#AFBCBC",
    stopOpacity: 0.179
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B6A6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_819_10162",
    x1: 31,
    y1: 23.1641,
    x2: 31,
    y2: 60.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF0F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_819_10162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFile);
export default __webpack_public_path__ + "static/media/empty-file.508f878c97dc1da083b0a53bb0ed42c7.svg";
export { ForwardRef as ReactComponent };